<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="cancelEvent.emit()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        {{ "control_image_settings" | translate }}
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_alt" | translate }}
                </label>
                <div class="col-xs-12">
                    <input class="form-control" [formControl]="alt" />
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_link" | translate }}
                </label>
                <div class="col-xs-12" [class.has-warning]="!link.valid && link.touched">
                    <input class="form-control" placeholder="https://example.com" [formControl]="link" />
                    @if (!link.valid && link.touched) {
                        @if (link.errors.pattern) {
                            <small class="help-block mb-0">
                                {{ "control_errors_invalid_link" | translate }}
                            </small>
                        }
                    }
                </div>
                <div class="col-xs-12">
                    <label class="checkbox-inline">
                        <input type="checkbox" [formControl]="isTargetBlank" [checked]="isTargetBlank.value" />
                        {{ "control_target" | translate }}
                    </label>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-9 control-label">
                    {{ "content_image_overlay" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [active]="isImageEffect.value" (toggleActiveEvent)="setImageEffect($event)" />
                </div>
            </div>

            @if (isImageEffect.value) {
                <div class="form-group mb-10">
                    <label class="col-xs-12">
                        {{ "condition_type" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <select class="form-control" [formControl]="condition">
                            <option [ngValue]="EConditionType.ALWAYS">{{ "condition_type_always" | translate }}</option>
                            <option [ngValue]="EConditionType.ON_HOVER">
                                {{ "condition_type_on_hover" | translate }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group mb-10">
                    <label class="col-xs-12">
                        {{ "overlay" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <select class="form-control" [formControl]="overlay">
                            <option [ngValue]="null" disabled>{{ "overlay_type_empty" | translate }}</option>
                            <option [ngValue]="EOverlayType.TEXT">{{ "overlay_type_text" | translate }}</option>
                            @if (condition.value !== EConditionType.ON_HOVER) {
                                <option [ngValue]="EOverlayType.MASK">
                                    {{ "overlay_type_mask" | translate }}
                                </option>
                            }
                            @if (condition.value !== EConditionType.ALWAYS) {
                                <option [ngValue]="EOverlayType.IMAGE">
                                    {{ "overlay_type_image" | translate }}
                                </option>
                            }
                            @if (condition.value !== EConditionType.ALWAYS) {
                                <option [ngValue]="EOverlayType.INCREASE">
                                    {{ "overlay_type_increase" | translate }}
                                </option>
                            }
                            @if (condition.value !== EConditionType.ALWAYS) {
                                <option [ngValue]="EOverlayType.DECREASE">
                                    {{ "overlay_type_decrease" | translate }}
                                </option>
                            }
                        </select>
                    </div>
                </div>
                @if (overlay.value === EOverlayType.TEXT) {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_image_text" | translate }}
                            <span class="pull-right color-light char-count">
                                {{ description?.value?.length || 0 }}/{{ MAX_DESCRIPTION_LENGTH }}
                            </span>
                        </label>
                        <div class="col-xs-12">
                            <textarea
                                class="form-control"
                                [placeholder]="'default_description' | translate"
                                [maxLength]="MAX_DESCRIPTION_LENGTH"
                                [formControl]="description"
                            >
                            </textarea>
                        </div>
                    </div>
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_text_style" | translate }}
                        </label>
                        <div class="col-xs-4">
                            <sp-input-num
                                suffixText="px"
                                [max]="FONT_SIZE_MAX"
                                [value]="fontSize.value"
                                (valueChange)="setFontSize($event)"
                            />
                        </div>
                        <div class="col-xs-6">
                            <div class="btn-group btn-group-justified" data-toggle="buttons">
                                <label
                                    class="btn btn-grey active"
                                    [class.active]="isActiveTextStyle(EFontStyle.AT)"
                                    (click)="toggleActiveTextStyle(EFontStyle.AT)"
                                >
                                    <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                                </label>
                                <label
                                    class="btn btn-grey"
                                    [class.active]="isActiveTextStyle(EFontStyle.B)"
                                    (click)="toggleActiveTextStyle(EFontStyle.B)"
                                >
                                    <img src="./assets/img/lpc-icon-bold.svg" alt="B" />
                                </label>
                                <label
                                    class="btn btn-grey"
                                    [class.active]="isActiveTextStyle(EFontStyle.I)"
                                    (click)="toggleActiveTextStyle(EFontStyle.I)"
                                >
                                    <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                                </label>
                            </div>
                        </div>
                        <div class="col-xs-2">
                            <web-color-picker
                                [hideGradient]="true"
                                [color]="textColor.value"
                                (colorChangeEvent)="setTextColor($event)"
                            />
                        </div>
                    </div>
                    <div class="form-group mb-20">
                        <label class="col-xs-10 control-label">
                            {{ "control_background_color" | translate }}
                        </label>
                        <div class="col-xs-2">
                            <sp-color-picker
                                [colorsPreset]="selectedThemeColors()"
                                [color]="textBackground.value"
                                (colorChangeEvent)="setTextBackground($event)"
                            />
                        </div>
                    </div>
                    <div class="form-group mb-10">
                        <label class="col-xs-6">
                            {{ "control_padding" | translate }}
                        </label>
                        <div class="col-xs-6 text-right">
                            <div class="preset-padding-buttons">
                                <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(0)">0</button>
                                <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(15)">
                                    15
                                </button>
                                <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(30)">
                                    30
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-xs-12 d-flex">
                            <div class="d-flex align-items-center mr-5" style="flex-grow: 1">
                                <sp-input-num
                                    suffixText="px"
                                    [min]="SIZE_MIN"
                                    [max]="SIZE_MAX"
                                    [value]="paddingLeft.value"
                                    (valueChange)="setPaddingLeft($event)"
                                />
                            </div>
                            <div style="flex-grow: 1">
                                <div class="mb-10">
                                    <sp-input-num
                                        suffixText="px"
                                        [min]="SIZE_MIN"
                                        [max]="SIZE_MAX"
                                        [value]="paddingTop.value"
                                        (valueChange)="setPaddingTop($event)"
                                    />
                                </div>
                                <sp-input-num
                                    suffixText="px"
                                    [min]="SIZE_MIN"
                                    [max]="SIZE_MAX"
                                    [value]="paddingBottom.value"
                                    (valueChange)="setPaddingBottom($event)"
                                />
                            </div>
                            <div class="d-flex align-items-center ml-5" style="flex-grow: 1">
                                <sp-input-num
                                    suffixText="px"
                                    [min]="SIZE_MIN"
                                    [max]="SIZE_MAX"
                                    [value]="paddingRight.value"
                                    (valueChange)="setPaddingRight($event)"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-xs-12">
                            {{ "control_text_alignment" | translate }}
                        </label>
                        <div class="col-xs-6">
                            <sp-radio-group
                                [selected]="textJustify.value"
                                [type]="ERadioGroupType.horizontalPosition"
                                (changeSelectedEvent)="setTextJustify($event)"
                            />
                        </div>
                        <div class="col-xs-6">
                            <sp-radio-group
                                [selected]="textPosition.value"
                                [type]="ERadioGroupType.verticalPosition"
                                (changeSelectedEvent)="setTextPosition($event)"
                            />
                        </div>
                    </div>
                }
                @if (overlay.value === EOverlayType.MASK) {
                    <div class="form-group mb-20">
                        <div class="col-xs-12">
                            <div class="mask-wrapper">
                                @for (mask of EMaskShapeType | keyvalue; track mask) {
                                    <div
                                        (click)="setMaskType(mask.value)"
                                        [ngClass]="{ active: maskShape.value === mask.value }"
                                        class="mask-block carousel"
                                    >
                                        <div class="mask-shape" [ngClass]="mask.value"></div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
                @if (overlay.value === EOverlayType.IMAGE) {
                    <div class="form-group mb-20">
                        <sp-file-manager
                            [fmSourceType]="FmSourceType.LANDING"
                            [disabled]="buttonDisabled"
                            [file]="overlayImage.value"
                            [displayOnly]="[DirectoryItemCategory.Image]"
                            (setFileEvent)="setImage($event)"
                            (replaceFileEvent)="replaceImage($event)"
                        >
                            <ng-template
                                #previewTemplate
                                let-file="file"
                                let-replaceFileFn="replaceFileFn"
                                let-buildFilePreviewUrlsFn="buildFilePreviewUrlsFn"
                            >
                                <div class="mb-20">
                                    <sp-control-handle
                                        [controlHandleImagePreviewSources]="buildFilePreviewUrlsFn(file)"
                                        [controlHandleMainText]="file.name"
                                        (removeActionEvent)="removeFile()"
                                        (replaceActionEvent)="replaceFileFn()"
                                        [isDisableEditor]="false"
                                    />
                                </div>
                            </ng-template>
                        </sp-file-manager>
                    </div>
                }
            }
        </div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
